
import { defineComponent, ref, getCurrentInstance, onMounted, nextTick } from 'vue';
import { formatUrls } from '@/common/utils';
import { radarLog } from '@/common/radar';

export default defineComponent({
    components: {},
    props: {
        item: {
            type: Object,
            default: () => {
                ('');
            },
        },
        index: {
            type: Number,
            default: 0,
        },
        muted: {
            type: Boolean,
            default: false,
        },
        slideIndex: {
            type: Number,
            default: 0,
        },
    },
    setup(props, ctx) {
        const { proxy } = getCurrentInstance() as { proxy: any };
        const videoComp = ref<any>(null);
        const onClickVideo = (e: Event, refKey: string | number) => {
            // eslint-disable-next-line vue/require-explicit-emits
            ctx.emit('video-click', e, refKey);
        };

        const onWaiting = (e: Event, refKey: string | number) => {
            // eslint-disable-next-line vue/require-explicit-emits
            ctx.emit('video-waiting', e, refKey);
        };

        const onPlaying = (e: Event, refKey: string | number) => {
            // eslint-disable-next-line vue/require-explicit-emits
            ctx.emit('video-playing', props.index, refKey);
        };

        const onError = (e: any) => {
            radarLog({
                name: 'PWA_PC_VIDEO_DETAIL_ERROR',
                event_type: 'click',
                category: 'KWAI_SHARE',
                message: `error url: ${props.item?.main_mv_urls?.[0]?.url}`,
                src: window?.location.pathname,
            });
        };

        const onEnded = (e: Event, key: string) => {
            // eslint-disable-next-line vue/require-explicit-emits
            ctx.emit('ended', key);
        };

        const onPause = () => {
            console.log('onPause');
        };

        onMounted(() => {});
        return {
            videoComp,
            onClickVideo,
            onWaiting,
            onPlaying,
            formatUrls,
            onError,
            onEnded,
            onPause,
        };
    },
});
